export default __webpack_public_path__ + "static/media/map_recenter.e54ad88e.svg";